import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Observable, catchError, switchMap, throwError, tap } from 'rxjs';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import jwtDecode from 'jwt-decode';
import { UserService } from 'app/core/user/user.service';

export const authInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const snackBar = inject(MatSnackBar);
    const userService = inject(UserService);

    const isExternalApi =
        req.url.includes('nominatim.openstreetmap.org') ||
        req.url.includes('api-dofa.fff.fr') ||
        req.url.includes('restcountries.com') ||
        req.url.includes('openweathermap.org');

    const token = authService.accessToken;

    let newReq = req;
    if (!isExternalApi && token) {
        newReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`)
        });
    }

    return next(newReq).pipe(
        tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                const body = event.body;
                if (body?.updatedUser === true && body?.accessToken) {
                    const decodedToken: any = jwtDecode(body.accessToken);
                    userService.user = decodedToken;

                    snackBar.open(
                        'Profil mis à jour avec succès 🎉',
                        'Fermer',
                        { duration: 3000 }
                    );
                }
            }
        }),
        catchError((error: HttpErrorResponse) => {
            console.error('Erreur détectée :', error);

            if (error.status === 401 && error.error?.isTokenExpired) {
                console.warn('Token expiré. Tentative de refresh...');
                return authService.refreshToken().pipe(
                    switchMap((newToken: string | null) => {
                        if (newToken) {
                            const retriedReq = req.clone({
                                headers: req.headers.set('Authorization', `Bearer ${newToken}`)
                            });
                            return next(retriedReq);
                        } else {
                            authService.signOut();
                            router.navigate(['/sign-out']);
                            return throwError(() =>
                                new Error('Session expirée. Veuillez vous reconnecter.')
                            );
                        }
                    }),
                    catchError(() => {
                        authService.signOut();
                        router.navigate(['/sign-out']);
                        return throwError(() =>
                            new Error('Session expirée. Veuillez vous reconnecter.')
                        );
                    })
                );
            }

            return throwError(() => error);
        })
    );
};
